import Vue from "vue"

const CustomEvents = new Vue({
})

export default CustomEvents
